import { ActivitiesReportPreviewResponseSchema, } from '@packages/types';
import { api, downloadFile } from '../client.js';
function buildActivitiesReportQueryString(filters, columns, orientation) {
    const params = new URLSearchParams();
    if (filters.dateFrom)
        params.set('dateFrom', filters.dateFrom);
    if (filters.dateTo)
        params.set('dateTo', filters.dateTo);
    for (const id of filters.performedByUserId ?? [])
        params.append('performedByUserId', id);
    for (const id of filters.clientProjectId ?? [])
        params.append('clientProjectId', id);
    for (const id of filters.clientId ?? [])
        params.append('clientId', id);
    for (const s of filters.status ?? [])
        params.append('status', s);
    if (filters.chargeType && filters.chargeType !== 'all') {
        params.set('chargeType', filters.chargeType);
    }
    for (const col of columns ?? [])
        params.append('columns', col);
    if (orientation)
        params.set('orientation', orientation);
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
export function getActivitiesReportPreview(accountId, filters) {
    const qs = buildActivitiesReportQueryString(filters);
    return api(`/accounts/${accountId}/activities-report/preview${qs}`, ActivitiesReportPreviewResponseSchema);
}
export async function downloadActivitiesReportXlsx(accountId, filters, columns) {
    const qs = buildActivitiesReportQueryString(filters, columns);
    return downloadFile(`/accounts/${accountId}/activities-report.xlsx${qs}`, 'activities-report.xlsx');
}
export async function downloadActivitiesReportPdf(accountId, filters, columns, orientation) {
    const qs = buildActivitiesReportQueryString(filters, columns, orientation);
    return downloadFile(`/accounts/${accountId}/activities-report.pdf${qs}`, 'activities-report.pdf');
}
